<template>
	<div class="container">
		<div class="btn" v-for="angle in angles" :key="angle.view">
			<xl-tooltip :content="$t(`modelData.${angle.key}View`)" placement="top">
				<i :class="['iconfont',angle.icon]" @click="onClick(angle)"></i>
			</xl-tooltip>
		</div>
	</div>
</template>

<script setup>
import { XlTooltip } from '@shining3d/ui-components';
import { useLang } from "@shining3d/common-module/utils/lang.js";

const emit = defineEmits(['change']);
const { $t } = useLang( '@shining3d/xl-design-order' );

const angles = [
	{
		key: 'front',
		view: 'envisage',
		icon: 'icon-zhengshitu'
	},
	{
		key: 'back',
		view: 'backView',
		icon: 'icon-houshitu'
	},
	{
		key: 'top',
		view: 'topView',
		icon: 'icon-shangshitu'
	},
	{
		key: 'bottom',
		view: 'bottomView',
		icon: 'icon-xiashitu'
	},
	{
		key: 'left',
		view: 'leftView',
		icon: 'icon-zuoshitu'
	},
	{
		key: 'right',
		view: 'rightView',
		icon: 'icon-youshitu'
	}
];
function onClick( params ) {
	emit( 'change', params.view );
}
</script>

<style scoped lang="scss">
.container {
	width: 100%;
	height: 28px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-top: 8px;
	border-top: 2px solid #E0E4EA;
	margin-top: 16px;
	.btn {
		// height: 20px;
	}
	.iconfont {
		cursor: pointer;
		font-size: 20px;
		color: #737E99;
	}

	.iconfont {
		color: $color-n8;
		border-radius: 2px;
		padding: 4px;

		&:hover {
			background-color: $color-n4;
		}
	}
}
</style>
